import React, { useEffect, useState } from 'react';

export type Dimension = { height: number; width: number };
/**
 * Hook to get height and width using ref of an element.
 * @param targetRef - Ref of an element.
 * @returns - Height and width of the element.
 */
const useDimensions = (targetRef: React.RefObject<HTMLDivElement>): Dimension => {
  /**
   * Function to get Dimension.
   * @returns - Height and Width.
   */
  const getDimensions = (): Dimension => {
    return {
      width: targetRef.current ? targetRef.current.offsetWidth : 0,
      height: targetRef.current ? targetRef.current.offsetHeight : 0
    };
  };

  const [dimensions, setDimensions] = useState<Dimension>({} as Dimension);

  /**
   * Function to update state.
   */
  const handleResize = (): void => {
    setDimensions(getDimensions());
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  useEffect(() => {
    handleResize();
  }, []);

  return dimensions;
};

export default useDimensions;
